module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_9006.9781d056.png";